import Slider from 'components/slider';
import Header from 'modules/productDetail/header';
import Title from 'modules/productDetail/title';
import RemainingTime from 'modules/productDetail/remainingTime';
import Price from 'modules/productDetail/price';
import Existing from 'modules/productDetail/existing';
import Description from 'modules/productDetail/description';
import AddWanted from 'modules/productDetail/addWanted';
import Location from 'modules/productDetail/location';
import Roles from 'modules/productDetail/roles';
import ReportViolation from 'modules/productDetail/reportViolation';
import MessageButton from 'modules/productDetail/messageButton';
import CallButton from 'modules/productDetail/callButton';
import useSetSliderImages from '../hooks/useSetSliderImages';
import EmptyImage from 'assets/images/noImage/background store 4.svg';
import {toPersianExisting} from 'utilities/helper/toPersianUnits/existing';
import AddWantedModal from 'components/modal/wholesaler/addWantedModal';
import {useState} from 'react';
import AddWantedModalFarm from 'components/modal/farm/addWantedModal';
import {useParams} from 'react-router-dom';
import Distinguished from '../distinguished';
const SaleDetail = ({
  post,
  app,
  postGUID,
  setOpenViolationModal,
}: ISaleDetail) => {
  const [showModal, setShowModal] = useState(false);
  const params = useParams();
  const {sliderImages} = useSetSliderImages({
    mainImage: post.main_image,
    images: post.images,
  });
  return (
    <div className=" px-3 mt-8">
      <Header post={post} />
      {sliderImages.length > 1 ? (
        <Slider images={sliderImages} />
      ) : sliderImages.length === 1 ? (
        <img
          alt="slider"
          src={sliderImages[0]}
          className=" block mx-auto w-36"
        />
      ) : (
        <div className="bg-gray-11 w-full flex h-[200px] rounded-lg my-2">
          <img
            alt="empty"
            src={EmptyImage}
            className=" block mx-auto w-36 bg-gray-11"
          />
        </div>
      )}
      <Title title={post.title} />
      <RemainingTime remainingTime={post.sale?.expire_date} />
      <Price
        price={
          post.negotiated_price
            ? 'توافقی'
            : `${Number(post.sale?.realtime_price).toLocaleString()} تومان`
        }
      />
      <Existing
        existing={post.existing}
        option={toPersianExisting[post.existing_unit]}
      />
       {post.is_distinguished && <Distinguished date = {post.cultivation?.harvest_datetime} />}
      {post.description && <Description description={post.description} />}
      <AddWanted setShowModal={setShowModal} />
      {post.state && (
        <Location
          location={`${post.state.name} ${
            post.city ? ',' + post.city.name : ''
          }`}
        />
      )}
      <Roles app={app} />
      <ReportViolation setOpenViolationModal={setOpenViolationModal} />
      <div className="flex gap-4 mt-3 pb-12">
        <MessageButton
          post={postGUID}
          post_type={post.post_type}
          profile_type={post.profile_type}
          disabled={post?.sale?.is_expired || post.sale_status?.is_saled}
        />
        {post.phone_number && (
          <CallButton
            disabled={post?.sale?.is_expired || post.sale_status?.is_saled}
            phone={post.phone_number}
          />
        )}
      </div>
      {app === 'market' ? (
        <AddWantedModal
          showModal={showModal}
          setShowModal={setShowModal}
          title={post.title}
          city={post.city && post.city.name}
          state={post.state && post.state.name}
          app={app}
          guid={params.guid}
        />
      ) : (
        <AddWantedModalFarm
          showModal={showModal}
          setShowModal={setShowModal}
          title={post.title}
          city={post.city && post.city.name}
          state={post.state && post.state.name}
          app={app}
          guid={params.guid}
        />
      )}
    </div>
  );
};

export default SaleDetail;
